import { useState, useMemo } from 'react';

export const useInitials = (firstName: string, lastName: string) => {
    const [initials, setInitials] = useState('');

    const generateInitials = (firstName: string, lastName: string) => {
        const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
        const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';

        return firstInitial + lastInitial;
    };

    const memoizedGenerateInitials = useMemo(() => generateInitials, []);

    useMemo(() => {
        const newInitials = memoizedGenerateInitials(firstName, lastName);
        setInitials(newInitials);
    }, [firstName, lastName, memoizedGenerateInitials]);

    return initials;
};
